import React, { useState, useEffect, useCallback } from 'react';
import { Layout } from 'antd';
import Sidebar from '../Sidebar/Sidebar';
import { openNotification, useDimensions } from '../../utils/helpers/global';
import AppContent from '../Content/Content';
import SOCKET_CONSTANTS from '../../constants/event.constant';
import { Emitter } from '../../utils/service';
import { eventOperation, eventType, processesStatuses } from '../../constants/app.constants';

import styles from './layout.module.scss';
const AppLayout = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const { width } = useDimensions();
  useEffect(() => {
    if (width < 1025) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [width]);

  useEffect(() => {
    Emitter.off(SOCKET_CONSTANTS.INCOMING_NOTIFICATION_EVENT_NAME, notificationHandler);
    Emitter.on(SOCKET_CONSTANTS.INCOMING_NOTIFICATION_EVENT_NAME, notificationHandler);
    return () => {
      Emitter.off(SOCKET_CONSTANTS.INCOMING_NOTIFICATION_EVENT_NAME, notificationHandler);
    };
  }, []);

  const notificationHandler = (data) => {
    let message = '';
    let status = data?.content?.data?.status;
    if (data && data.content && data.content.type && data.content.operation) {
      let type = data.content.type;
      let operation = data.content.operation;
      switch (type) {
        case eventType.agent:
          switch (operation) {
            case eventOperation.insert:
              message = `Agent ${data.content?.data?.deviceId} Added successfully`;
              break;
            case eventOperation.update:
              message = `Agent ${data.content?.data?.deviceId} ${status == 0 ? 'Disconnected' : 'Connected'} successfully`;
              break;
          }
          break;
        case eventType.process:
          switch (operation) {
            case eventOperation.insert:
              message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Added successfully`;
              break;
            case eventOperation.update:
              if (data.content?.data?.status === processesStatuses.running) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Started Running`;
              } else if (data.content?.data?.status === processesStatuses.executed) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Completed Successfully`;
              } else if (data.content?.data?.status === processesStatuses.failed) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Failed`;
              } else if (data.content?.data?.status === processesStatuses.canceled) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Canceled`;
              } else if (status === processesStatuses.agentDisconnected) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... failed since agent is disconnected`;
              }
              break;
          }
          break;
        case eventType.processExecutionLog:
          switch (operation) {
            case eventOperation.insert:
              break;
            case eventOperation.update:
              break;
          }
          break;
      }
    }
    if (message) {
      openNotification(message);
      message = '';
    }
  };

  const onCollapse = useCallback(
    (collapsed) => {
      setCollapsed(collapsed);
    },
    [width, collapsed]
  );

  const toggle = () => {
    setCollapsed(!collapsed);
  };
  return (
    <div className={styles.layoutContainer}>
      <div className={styles.sideBarContainer}>
        <Sidebar collapsed={collapsed} onCollapse={onCollapse} {...props} />
      </div>

      <div className={styles.contentContainer}>
        <AppContent {...props} />
      </div>
    </div>
  );
};

export default AppLayout;
